export default {
  namespaced: true,

  state: () => ({
    submitCallback: null,
    updateCallback: null,
    dirty: false,
    valid: true,
    updateLoading: false,
    deleteLoading: false,
    currentPodcast: null,
  }),

  getters: {
    actionsLoading(state) {
      return state.updateLoading || state.deleteLoading
    },
  },

  mutations: {
    setSubmitCallback(state, callback) {
      state.submitCallback = callback
    },
    setUpdateCallback(state, callback) {
      state.updateCallback = callback
    },
    setUpdateLoading(state, loading) {
      state.updateLoading = loading
    },
    setDeleteLoading(state, loading) {
      state.deleteLoading = loading
    },
    setDirty(state, dirty) {
      state.dirty = dirty
    },
    setValid(state, valid) {
      state.valid = valid
    },
    setCurrentPodcast(state, podcast) {
      state.currentPodcast = podcast
    },
  },

  actions: {
    async update({ state, commit }) {
      commit('setUpdateLoading', true)

      try {
        const res = await state.submitCallback()
        state.updateCallback(null, res)
      } catch (err) {
        state.updateCallback(err, null)
      }

      commit('setUpdateLoading', false)
    },
  },
}
